<template>
  <v-container
    class="onboarding-copy-code"
    align-center
    justify-center
    fill-height
  >
    <v-layout column align-center justify-center>
      <div class="header">Well done!</div>
      <!-- <div class="preview-link-box">
        Check the survey
        <a
          target="_blank"
          :href="
            '/preview-manager/feedback/' +
              $store.getters['user/currentCampaign'].id +
              '/' +
              'NPS'
          "
          >preview here</a
        >
      </div> -->
      <div class="copy-header">
        Please copy and paste the script in your app/product to start using
        Loyagram
      </div>
      <textarea
        ref="textarea"
        class="code-text-area"
        :value="codeSnippet"
        @click="copy"
        readonly
      ></textarea>
      <!--<script>-->
      <!--var loyagram = new LoyagramWidget('{{ campaignSettings.id }}')-->
      <!--loyagram.setUserId('test@domain.com')-->
      <!--loyagram.setAttributes({planId: 1, product: test})-->
      <!--</script>-->
      <div class="actions">
        <v-btn
          dark
          color="primaryLight1"
          medium
          depressed
          class="copy-code-button"
          @click="copy"
        >
          <img
            class="v-icon v-icon--left"
            :src="require('@/assets/copy.svg')"
          />
          Copy Script
        </v-btn>
        <div v-if="onboarding" class="or">OR</div>
        <router-link
          v-if="onboarding"
          :to="{
            name: routeNames.SURVEY_CUSTOMIZE,
            params: {
              projectId: $store.getters['user/currentCampaign'].project_id,
              campaignId: $store.getters['user/currentCampaign'].id
            }
          }"
          ><v-btn color="accent" depressed>
            Customise Survey
          </v-btn></router-link
        >
      </div>
    </v-layout>
  </v-container>
</template>

<script>
import EventBus from '@/event_bus'
import routes from '@/route_names'
export default {
  name: 'OnboardingCopyCode',
  props: {
    campaign: { type: Object },
    onboarding: { type: Boolean, default: false }
  },
  computed: {
    campaignSettings() {
      return {
        id: this.campaign.id
      }
    },
    routeNames: function() {
      return routes
    },
    link: function() {
      return process.env.VUE_APP_FEEDBACK_JS_URL
    },
    codeSnippet: function() {
      const attrs = [
        `src="${this.link}"`,
        `data-campaign-id="${this.campaign.id}"`,
        'defer'
      ]

      if (process.env.VUE_APP_API_BASE) {
        attrs.splice(2, 0, `data-api-base="${process.env.VUE_APP_API_BASE}"`)
      }

      return '<script ' + attrs.join(' ') + '></' + 'script>'
    }
  },
  methods: {
    copy: function() {
      this.$refs.textarea.select()
      document.execCommand('copy')
      EventBus.$emit('SHOW_SNACK', { msg: 'Script copied to your clipboard' })
    }
  }
}
</script>

<style lang="stylus">
.onboarding-copy-code {
    text-align: center
    .header {
        font-size: 18px
        font-weight: bold
    }
    .preview-link-box {
        margin-top 25px
        font-size 16px
        a {
            font-weight  bold
            text-underline none
            text-decoration none
            padding-bottom 3px
            border-bottom 3px solid $color-accent
        }
    }

    .copy-header {
        margin-top 75px
        font-size 16px
        font-weight 500
        margin-bottom  18px
    }

    .code-text-area {
        background: #F5F9FD;
        border: 1px solid #F1F2F6;
        box-sizing: border-box;
        border-radius: 5px 0px 0px 5px;
        width 500px
        height: 135px;
        padding: 30px;
        overflow-y: hidden;
    }

    .copy-code-button {
        background-color $color-primary-light-1
    }

    .actions {
        margin-top 30px
        .or {
            margin 30px 0
        }
        a {
            text-decoration none
            text-underline none
        }
    }
}
</style>
